export const NERDWALLET_LIGHT_TOUCH = 'nerdwallet_light_touch'
export const NERDWALLET_ASSETS = 'nerdwallet_assets'
export const JOURNEY_PARAM_NAME = 'journey'
export const LP = 'lp'
export const ASSETS_QUESTION = 'assets_question'
export const USWITCH_MODAL = 'uswitch_modal'
export const MODAL = 'modal'
export const USW_THINK_TEST = 'usw-think-test'
